















import { Vue } from "vue-property-decorator";

export default Vue.extend({
  props: {
    channelName: {
      default: "derpislands",
      type: String
    }
  }
});
